module.exports = __webpack_public_path__ + "c16e7665361c8624c7f5e4a11fffc922.pdf";